mutation TranscriptSummaryDelete($input: TranscriptSummaryDeleteInput!) {
    transcriptSummaryDelete(input: $input) {
        activity {
            id
            summary {
                id
                status
                summary
            }
            generatingSummary
            summaryStates {
                recordingEmptyState
                transcriptionEmptyState
                summaryEmptyState
                summaryNextAction
            }
        }
    }
}
